// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HitsAnglesGraphs_wrapper__1qybO"};